/**
 * Utilitaire pour résoudre l'URL de l'application
 * Utilise plusieurs sources possibles avec ordre de priorité :
 * 1. AUTH_REDIRECT_URLS (liste d'origins autorisées, séparées par des virgules)
 * 2. REACT_APP_AUTH_REDIRECT_URLS (fallback pour CRA)
 * 3. REACT_APP_APP_URL (compatibilité avec l'existant)
 * 4. window.location.origin (si côté client)
 * 5. http://localhost:3000 (dernier recours)
 */
export function resolveAppUrl(): string {
  // 1) lire la liste (ex: "https://appli.fginvest.pro,http://localhost:3000")
  const raw = process.env.AUTH_REDIRECT_URLS
           || process.env.REACT_APP_AUTH_REDIRECT_URLS   // fallback CRA
           || process.env.REACT_APP_APP_URL              // compat actuelle
           || '';

  const list = raw.split(',').map(s => s.trim()).filter(Boolean);

  // 2) si on est côté client, essayer de matcher l'origin courante
  if (typeof window !== 'undefined') {
    const current = window.location.origin;
    const match = list.find(u => u === current);
    if (match) return match;
  }

  // 3) sinon, prendre la 1re de la liste si dispo,
  //    ou l'origin courante, ou enfin localhost
  return list[0]
      || (typeof window !== 'undefined' ? window.location.origin : 'http://localhost:3000');
}

